import * as React from 'react';
import { colors } from '../../../index';

const IconOptions = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 4 17",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.885 2.111c0 .625-.177 1.107-.53 1.447-.355.34-.798.51-1.33.51-.524 0-.958-.17-1.303-.51-.344-.34-.516-.822-.516-1.447 0-.597.17-1.07.51-1.419.34-.349.776-.524 1.308-.524.533 0 .976.17 1.33.51.354.34.53.818.53 1.433zm0 6.311c0 .625-.177 1.107-.53 1.447-.355.34-.798.51-1.33.51-.524 0-.958-.17-1.303-.51-.344-.34-.516-.822-.516-1.447 0-.597.17-1.07.51-1.419.34-.35.776-.524 1.308-.524.533 0 .976.17 1.33.51.354.34.53.818.53 1.433zm0 6.077c0 .625-.177 1.107-.53 1.447-.355.34-.798.51-1.33.51-.524 0-.958-.17-1.303-.51-.344-.34-.516-.822-.516-1.447 0-.597.17-1.07.51-1.42.34-.348.776-.523 1.308-.523.533 0 .976.17 1.33.51.354.34.53.817.53 1.433z",
    fill: "currentColor"
  }));
};

export default IconOptions;